import React, { Fragment, useEffect, useState } from "react";
import { useFilePicker } from "use-file-picker";
import { IonIcon, IonModal, IonButton, IonRow, IonCol } from "@ionic/react";
import "./EMTMediaUpload.scss";
import {
  attach,
  camera,
  close,
  imagesOutline,
  mic,
  videocam,
  videocamOutline,
} from "ionicons/icons";
import sanitizeHtml from "sanitize-html";
import _, { isEmpty } from "lodash";
import { utilService } from "../../../../services";
import { useHistory, useLocation } from "react-router";
import { CONSTANTS } from "../../../../constants";
import { EMSImageService } from "../EMSImageComponent/EMSImageComponent.service";
import { EMSAudioService } from "../EMSAudioComponent/EMSAudioComponent.service";
import { useToast } from "@agney/ir-toast";
import { EMSVideoService } from "../EMSVideoComponent/EMSVideoComponent.service";
import EMSAudioComponent from "../EMSAudioComponent/EMSAudioComponent";
import EMSVideoComponent from "../EMSVideoComponent/EMSVideoComponent";
import { dataTransferService } from "../../../../services/dataTransferService";
import EMSImageComponent from "../EMSImageComponent/EMSImageComponent";
import Loader from "../../../../components/Shared/Loader/Loader";
import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";
import { usePhoto } from "../../../../hooks/usePhoto";
import { isPlatform } from "@ionic/core";
import { userMessageService } from "../../../UserMessages/UserMessage.service";
import { MediaUploadService } from "./EMTMediaUpload.service";
import EMSMediaUploadCard from "./Components/EMTMediaUploadCard";
import { useTranslation } from "react-i18next";

// Megabytes. Matches the threshold this screen has always used; it is a
// client-side guard only, the server enforces its own limit.
const MAX_UPLOAD_SIZE_MB = 150;
declare const MediaRecorder: any;
declare const Recorder: any;

interface mediaUploadProps {
  isGroupMediaShare?: boolean;
  doctorListDataFromParent?: any;
  isNotificationCard?: boolean;
  isDoctorCardFileShare?: boolean;
  isShowNamesList?: boolean;
  isProviderCard?: boolean;
  dataFromParentComponent?: any;
  onOk: () => void;
  onCancel: () => void;
  patientId?: any;
  isStatusBoard?: boolean;
  isSmallScreen?: boolean;
  initValue?: any;
  isMessageComponent?: boolean;
  isUploadAttachment?: boolean;
  smsThread: any;
  selectedUsers?: any;
  isFromPatientForm?: any;
  patientDetailsSubmitted?: boolean;
  patientDataID?: any;
  siteGUID?: any;
  hideAttach?: any;
  getMediaUploadStatus?: any;
  isFromCaseDetailsEdit?: any;
  updateDetailsPage?: any;
  attachmentActive?: any;
  isTransferred?: any;
  isEMTUser?: any;
}

const EMTMediaUpload: React.FC<mediaUploadProps> = (props) => {
  const { t } = useTranslation("ems");
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isVideoRecording, setIsVideoRecording] = useState(false);
  const [isImageRecording, setIsImageRecording] = useState(false);
  const [isRoutedFromMediaList, setIsRoutedFromMediaList]: any =
    useState(false);
  const [mediaItem, setMediaItem]: any = useState([]);
  const [clientMediaID, setClientMediaID]: any = useState(Number);
  const [fileSize, setFileSize]: any = useState("");
  const [mediaType, setMediaType]: any = useState();
  const [mediaAction, setMediaAction]: any = useState();
  const [userMessage, setUserMessage]: any = useState("");
  const [selectedDoctorData, setSelectedDoctorDta]: any = useState([]);
  const [displayMediaList, setDisplayMediaList]: any = useState([]);
  var [showLoader, setShowLoader] = useState(false);
  const [disableSendButton, setDisableSendButton] = useState(true);
  const [isVideoDeviceAvailable, setIsVideoDeviceAvailable] = useState(true);
  const [viewAttachment, setViewAttachment] = useState(false);
  const [isMediaAttach, setMediaAttach] = useState(false);
  const [isAudioDeviceAvailable, setIsAudioDeviceAvailable] = useState(true);
  const [isShowPopOver, setShowPopover] = useState(false);
  const [isShowRecordMediaPopOver, setShowRecordMediaPopover] = useState(false);
  const [toggleAttachment, setToggleAttachment] = useState(false);
  const [timerIntervalID, setTimerIntervalID]: any = useState("");
  const [columnSize, setColumnSize]: any = useState("12");
  const [userTextMessage, setMessage]: any = useState("");
  const [isEKG, isEKGSelected] = useState(false);
  const [isFromEMTStartACase, isSetFromEMTStartACase] = useState(false);
  const [disableMediaSection, setDisableMediaSection] = useState(false);
  const [disableAudioSection, setDisableAudioSection] = useState(false);

  // audio picker package
  const [openFileSelector, { plainFiles }] = useFilePicker({
    accept: ".mp3,.wav,audio/",
  });

  let mediaUploadListLength = 0;

  let history = useHistory();
  const location: any = useLocation();
  const Toast = useToast();

  const [base64, setBase64] = useState("");

  const { takePhoto, photos } = usePhoto();

  useEffect(() => {
    setUploadImage();
  }, [photos]);

  useEffect(() => {
    if (displayMediaList.length === 0) {
      setToggleAttachment(false);
      setDisableAudioSection(false);
      if (props.getMediaUploadStatus) {
        props.getMediaUploadStatus(displayMediaList.length);
      }

      setMessage("");
    } else if (displayMediaList.length > 0) {
      setMessage("media message");
      if (props.getMediaUploadStatus) {
        props.getMediaUploadStatus(displayMediaList.length);
      }
    }
  }, [displayMediaList]);

  useEffect(() => {
    if (!_.isEmpty(plainFiles)) {
      const fileCollection: any = plainFiles;
      for (var index = 0; index < fileCollection.length; index++) {
        const fileData = fileCollection[index];
        const clientMediaID = Math.floor(Math.random() * 10000);
        setClientMediaID(clientMediaID);
        fileData["clientMediaID"] = clientMediaID;
        setNativeTemp(fileData, 2);
      }
      setShowPopover(false);
      setMediaAttach(true);
    }
  }, [plainFiles]);

  useEffect(() => {
    if (props.patientDetailsSubmitted) {
      let mediaUploadMessage = "sample";
      setParams(mediaUploadMessage);
    }
  }, [props.patientDetailsSubmitted]);

  const setUploadImage = () => {
    var initValueBase = props.initValue == null ? "" : props.initValue;
    var bSixtyFour = photos != undefined ? photos.base64 : initValueBase;
    setBase64(bSixtyFour);
    let imageFileName;
    if (isEKG) {
      imageFileName =
        "EKG_" +
        new Date().toISOString().slice(0, 10) +
        "_" +
        new Date().toLocaleTimeString();
    } else {
      imageFileName =
        "IMG_" +
        new Date().toISOString().slice(0, 10) +
        "_" +
        new Date().toLocaleTimeString();
    }

    if (!_.isEmpty(bSixtyFour)) {
      let imageFile: any = dataURLtoFile(bSixtyFour, imageFileName);
      const clientMediaID = Math.floor(Math.random() * 10000);
      setClientMediaID(clientMediaID);
      imageFile["clientMediaID"] = clientMediaID;
      let mediaTypeSelected = isEKG ? 5 : 1;
      setNativeTemp(imageFile, mediaTypeSelected);
      setMediaAttach(true);
    }
  };

  useEffect(() => {
    clearMediaFileArray();
    if (utilService.isWeb()) {
      if (props.selectedUsers.length > 1) {
        setVideoAndAudioDeviceStatus();
      }
    }
    props.isSmallScreen ? setColumnSize("12") : setColumnSize("6");
    if (props.isMessageComponent) {
      setColumnSize("6");
    }
    return () => {
      dataTransferService.transferEMSAudioMediaAction(false);
    };
  }, []);

  useEffect(() => {
    if (utilService.isWeb() && showVideoUploadModal) {
      setVideoAndAudioDeviceStatus();
    }
  }, [showVideoUploadModal]);

  const dataURLtoFile = (dataUrl: any, filename: any) => {
    var dataArray = dataUrl.split(","),
      mime = dataArray[0].match(/:(.*?);/)[1],
      bstr = atob(dataArray[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const setVideoAndAudioDeviceStatus = () => {
    var localVideoStream: any;
    var localAudioStream: any;
    navigator.mediaDevices.getUserMedia(
      { video: true })
      .then(function (stream: { getTracks: () => any[] }) {
        setIsVideoDeviceAvailable(true);
        localVideoStream = stream;
        stream
          .getTracks()
          .forEach((track: { stop: () => any }) => track.stop());
      },
      function () {
        setIsVideoDeviceAvailable(false);
      }
    );

    if (localVideoStream) {
      localVideoStream.getTracks().forEach((track: any) => track.stop());
    }

    navigator.mediaDevices.getUserMedia(
      { audio: true })
      .then(function (stream: { getTracks: () => any[] }) {
        setIsAudioDeviceAvailable(true);
        localAudioStream = stream;
        stream
          .getTracks()
          .forEach((track: { stop: () => any }) => track.stop());
      },
      function () {
        setIsAudioDeviceAvailable(false);
      }
    );

    if (localAudioStream) {
      localAudioStream.getTracks().forEach((track: any) => track.stop());
    }
  };

  const showAudioErrorMessage = () => {
    Toast.error(CONSTANTS.MESSAGES.NO_AUDIO_DEVICE);
  };

  useEffect(() => {
    checkIfSmallScreen();
    if (props.dataFromParentComponent) {
      setIsRoutedFromMediaList(
        props.dataFromParentComponent.isCalledFromMediaListComponent
      );
    }
    if (props.isGroupMediaShare === true) {
      setUiForGroupMediaShareModal();
      setSelectedDoctorDta(props.doctorListDataFromParent);
    } else if (props.isMessageComponent === true) {
      setSelectedDoctorDta(props.doctorListDataFromParent);
    }
    return () => {
      utilService.showFooterTab();
    };
  }, []);

  useEffect(() => {
    setSelectedDoctorDta(props.doctorListDataFromParent);
  }, [props.doctorListDataFromParent]);

  useEffect(() => {
    if (
      !_.isEmpty(location.state) &&
      location.pathname === "/client/file-share/upload-media"
    ) {
      const currentLocation: any = location;
      setMediaItem(currentLocation.state.mediaItem);
      setIsRoutedFromMediaList(
        currentLocation.state.isCalledFromMediaListComponent
      );
      setSelectedDoctorDta(currentLocation.state.selectedDoctorData);
      setMediaAction(currentLocation.state.mediaAction);
    }
  }, [location]);

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const clearMediaFileArray = () => {
    EMSImageService.displayEMSImageList = [];
    EMSImageService.uploadEMSImageList = [];
    EMSImageService.EKGDisplayImageList = [];
    EMSImageService.EKGUploadImageList = [];
    EMSAudioService.displayAudioList = [];
    EMSAudioService.uploadAudioList = [];
    EMSVideoService.displayEMSVideoList = [];
    EMSVideoService.uploadEMSVideoList = [];
  };

  const setUiForGroupMediaShareModal = () => {
    const mediaListContainer = document.getElementById(
      "uploaded-media-list-container"
    );
    mediaListContainer?.style.setProperty("height", "220px");

    const mediaUploadTextBox = document.getElementById("media-upload-text-box");
    mediaUploadTextBox?.style.setProperty("width", "350px");
  };

  const openModalPopUp = (type: Number) => {
    setMediaType(type);
    setIsVideoRecording(false);
    if (utilService.isWeb()) {
      setShowVideoUploadModal(true);
      setMediaAttach(true);
    } else {
      dataTransferService.transferEMSVideoMediaAction(!isVideoRecording);
    }
  };

  const closeModalPopUp = (type: Number) => {
    setShowVideoUploadModal(false);
  };

  const onCardRemove = () => {
    props.attachmentActive(false);
    setDisableAudioSection(false);
    setDisableMediaSection(false);
    setMediaList();
    // setMediaAttach(false);
    // setViewAttachment(false);
    if (props.isFromCaseDetailsEdit) {
      clearStoredServiceMediaList();
    }
  };

  const setMediaList = () => {
    setDisableSendButton(false);
    const mediaList = [
      ...EMSImageService.displayEMSImageList,
      ...EMSImageService.EKGDisplayImageList,
      ...EMSAudioService.displayAudioList,
      ...EMSVideoService.displayEMSVideoList,
    ];
    setDisplayMediaList(_.cloneDeep([...mediaList]));
  };

  const webAttachMedia = (mediaType: any) => {
    let file: any = "";
    if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      file = document.getElementsByName("audio-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      file = document.getElementsByName("image-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.EKG) {
      file = document.getElementsByName("ekg-file")[0] as any;
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.VIDEO) {
      file = document.getElementsByName("video-file")[0] as any;
    }
    const fileCollection: any = file.files;
    for (var index = 0; index < fileCollection.length; index++) {
      const fileData = fileCollection[index];
      const clientMediaID = Math.floor(Math.random() * 10000);
      setClientMediaID(clientMediaID);
      fileData["clientMediaID"] = clientMediaID;
      setNativeTemp(fileData, mediaType);
    }
    setShowPopover(false);
    setMediaAttach(true);
  };

  const setNativeTemp = async (file: any, mediaType: any) => {
    const base64Data = (await convertBlobToBase64(file)) as string;
    const params = {
      name: file.name,
      nativeURL: base64Data,
      type: mediaType,
      isNative: false,
      clientMediaID: file.clientMediaID,
      size: utilService.formatBytes(file.size),
      isAttach: true,
    };
    storeToDisplayService(params, mediaType);
    setWebParams(file, mediaType);
  };

  const convertBlobToBase64 = (blob: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });

  const getBase64 = (file: any) => {
    // const self = this;
    // var reader = new FileReader();
    // reader.readAsDataURL(file);

    const reader = new FileReader();

    reader.readAsArrayBuffer(file);

    reader.onload = () => {
      // get the blob of the image:
      let blob: Blob = new Blob([new Uint8Array(reader.result as ArrayBuffer)]);

      // create blobURL, such that we could use it in an image element:
      let blobURL: string = URL.createObjectURL(blob);
      let sanitizedUrl = sanitizeHtml(blobURL);
      setFileSize(utilService.formatBytes(file.size));
      const params = {
        name: file.name,
        nativeURL: sanitizedUrl,
        type: mediaType,
        isNative: false,
        clientMediaID: file.clientMediaID,
        size: utilService.formatBytes(file.size),
        isAttach: true,
      };
      // storeToDisplayService(params);
      // setWebParams(file);
    };

    reader.onerror = (error) => {
      //handle errors
    };
  };

  const setWebParams = (fileData: any, mediaType: any) => {
    const params = {
      clientMediaID: fileData.clientMediaID,
      from_guid: utilService.getLoggedUserGuid(),
      type: mediaType,
      action: mediaAction,
      name: fileData.name.replace(/\s/g, "_"),
      file: fileData,
      size: utilService.formatBytes(fileData.size),
      patient_id: props.patientDataID,
    };
    if (mediaAction === CONSTANTS.MEDIA_ACTIONS.REPLY) {
      var replyParams = {
        clientMediaID: fileData.clientMediaID,
        from_guid: utilService.getLoggedUserGuid(),
        type: mediaType,
        action: mediaAction,
        id: parseMediaId(),
        name: fileData.name.replace(/\s/g, "_"),
        file: fileData,
        size: utilService.formatBytes(fileData.size),
        patient_id: props.patientDataID,
      };
      storeToUploadService(replyParams, mediaType);
    } else {
      storeToUploadService(params, mediaType);
    }
  };

  const parseMediaId = () => {
    if (!_.isEmpty(props.dataFromParentComponent)) {
      return props.dataFromParentComponent.mediaItem.id;
    } else {
      return mediaItem.id;
    }
  };

  const storeToDisplayService = (sanitizedUrl: any, mediaType: any) => {
    if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      EMSImageService.displayEMSImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.EKG) {
      EMSImageService.EKGDisplayImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      EMSAudioService.displayAudioList.push(sanitizedUrl);
    } else {
      EMSVideoService.displayEMSVideoList.push(sanitizedUrl);
    }
    setMediaList();
  };

  const storeToUploadService = (sanitizedUrl: any, mediaType: any) => {
    sanitizedUrl.type = mediaType;
    if (mediaType === CONSTANTS.MEDIA_TYPE.IMAGE) {
      EMSImageService.uploadEMSImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.EKG) {
      EMSImageService.EKGUploadImageList.push(sanitizedUrl);
    } else if (mediaType === CONSTANTS.MEDIA_TYPE.AUDIO) {
      EMSAudioService.uploadAudioList.push(sanitizedUrl);
    } else {
      EMSVideoService.uploadEMSVideoList.push(sanitizedUrl);
    }
  };

  const sendMedia = () => {
    var mediaUploadMessage: any = "";
    const mediaUploadTextBox = document.getElementById(
      "mediaMessageUploadTextBox"
    );
    if (mediaUploadTextBox) {
      mediaUploadMessage = mediaUploadTextBox.textContent;
      setUserMessage(mediaUploadMessage);
    }

    if (isMediaAttach) {
      setParams(mediaUploadMessage);
    } else {
      replayAllMessage(mediaUploadMessage);
    }
  };

  const parseToGuidUsers = () => {
    if (props.isNotificationCard) {
      if (!_.isEmpty(props.dataFromParentComponent)) {
        const initialArray: any = [];
        if (props.isStatusBoard) {
          initialArray.push(utilService.getLoggedUserGuid());
        } else {
          initialArray.push(props.dataFromParentComponent.selectedUserId);
        }
        return JSON.stringify(initialArray);
      } else {
        return JSON.stringify(selectedDoctorData);
      }
    } else {
      return JSON.stringify(
        doctorsListService.getSelectedUsersList(props.doctorListDataFromParent)
      );
    }
  };

  async function replayAllMessage(messages: any) {
    setShowLoader(true);
    const params = setAllReplyParams(messages);
    displayMediaList.length = 0;
    const respReplyAllListResult: any =
      await userMessageService.setReplyAllData(params);
    if (respReplyAllListResult.isSuccess) {
      Toast.success(CONSTANTS.MESSAGES.GROUP_SMS_SUCCESS);
      onCancelRequest();
      var mediaUploadMessage: any = "";
      const mediaUploadTextBox = document.getElementById("mediaUploadTextBox");
      if (mediaUploadTextBox) {
        mediaUploadTextBox.textContent = "";
      }
    } else {
      console.log("error");
    }
    setShowLoader(false);
  }

  const setAllReplyParams = (messages: any) => {
    let selectedUsersGuid: any = [];
    if (props.doctorListDataFromParent) {
      props.doctorListDataFromParent.map((items: any) => {
        selectedUsersGuid.push(items.guid);
      });
    } else {
      props.doctorListDataFromParent.map((items: any) => {
        selectedUsersGuid.push(items.guid);
      });
    }
    if (!_.isEmpty(messages)) {
      return {
        message_sms: messages,
        reg_code: utilService.getNetwork(),
        time: utilService.getCurrentDateAndTime(),
        users: selectedUsersGuid,
        sms_thread_id: getSMSThreadId(),
      };
    }
  };

  const getSMSThreadId = () => {
    if (props.smsThread) {
      return props.smsThread;
    } else if (location.state.msgData?.sms_thread_id) {
      return location.state.msgData.sms_thread_id;
    }
  };

  const setParams = (mediaUploadMessage: any) => {
    const uploadMediaList = [
      ...EMSImageService.uploadEMSImageList,
      ...EMSImageService.EKGUploadImageList,
      ...EMSAudioService.uploadAudioList,
      ...EMSVideoService.uploadEMSVideoList,
    ];
    uploadMediaList.forEach((element: any) => {
      element.message = mediaUploadMessage;
      element.reg_code = utilService.getNetwork();
      if (_.isEmpty(mediaAction)) {
        element.action = 1;
      }
      if (props.patientDataID) {
        element.patient_id = props.patientDataID;
      }
      if (mediaAction === CONSTANTS.MEDIA_ACTIONS.REPLY) {
        element.action = mediaAction;
        element.id = parseMediaId();
      }

      if (!_.isEmpty(props.dataFromParentComponent)) {
        element.action = props.dataFromParentComponent.mediaAction;
        element.id = parseMediaId();
      }
      if (props.siteGUID) {
        element.site_guid = props.siteGUID;
      }
      if (props.isFromCaseDetailsEdit) {
        element.update_media = true;
      }
      const media = {
        mediaData: element,
        uploadMediaList: uploadMediaList,
      };
      // element.size is megabytes (utilService.formatBytes divides by 1024^2).
      if (MAX_UPLOAD_SIZE_MB < Number(element.size)) {
        ifSizeIsLarge(element);
      } else {
        uploadMedia(media);
      }
    });
  };

  const uploadMedia = async (params: any) => {
    // setShowLoader(true);
    const formData = utilService.constructFormData(params.mediaData);
    const respFileShareMediaListResult: any =
      await MediaUploadService.mediaUpload(formData);
    mediaUploadListLength = mediaUploadListLength + 1;
    if (respFileShareMediaListResult.isSuccess) {
      clearUploadedServiceMediaList(params.mediaData);
    } else {
      setShowLoader(false);
      console.log("error");
    }
    if (mediaUploadListLength === params.uploadMediaList.length) {
      mediaUploadListLength = 0;
      setShowLoader(false);
      if (props.isFromCaseDetailsEdit) {
        Toast.success("media files uploaded");
        props.updateDetailsPage(props.patientDataID);
        clearStoredServiceMediaList();
      } else {
        Toast.success(CONSTANTS.MESSAGES.START_A_CASE);
        onCancelRequest();
        clearStoredServiceMediaList();
        enableRedirect();
        props.updateDetailsPage(props.patientDataID);
        //clear typed message after uploaded media
        const mediaUploadTextBox =
          document.getElementById("mediaUploadTextBox");
        if (mediaUploadTextBox) {
          mediaUploadTextBox.textContent = "";
        }
        setDisableSendButton(true);
      }
    }
    setShowLoader(false);
  };

  const enableRedirect = () => {
    history.push({
      pathname: "/client/emt-home",
    });
  };

  const clearUploadedServiceMediaList = (mediaData: any) => {
    const deleteStyle = document.getElementById(
      `media-${mediaData.clientMediaID}`
    );
    deleteStyle?.style.setProperty("display", "none");
    switch (mediaData.type) {
      case 1:
        _.remove(EMSImageService.uploadEMSImageList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
      case 2:
        _.remove(EMSAudioService.uploadAudioList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
      case 3:
        _.remove(EMSVideoService.uploadEMSVideoList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
      case 5:
        _.remove(EMSImageService.EKGUploadImageList, {
          clientMediaID: mediaData.clientMediaID,
        });
        break;
    }
  };

  const onCancelRequest = () => {
    let largeScreen = utilService.getScreenSize() === "large";
    let smallScreen = utilService.getScreenSize() === "small";
    let isOnCancelAvailable = "onCancel" in props;

    if (smallScreen) {
      history.goBack();
    } else if (largeScreen && isOnCancelAvailable) {
      props.onCancel();
    } else {
      history.goBack();
    }
    // setSearchText("");
  };

  const viewMediaAttachment = () => {
    setViewAttachment(true);
    props.attachmentActive(true);
    setDisableAudioSection(true);
    setDisableMediaSection(true);
    setToggleAttachment(true);
  };

  const clearStoredServiceMediaList = () => {
    clearMediaFileArrayUploads();
    setMessage("");
  };

  const clearMediaFileArrayUploads = () => {
    setDisplayMediaList((EMSImageService.displayEMSImageList = []));
    setDisplayMediaList((EMSImageService.EKGDisplayImageList = []));
    setDisplayMediaList((EMSImageService.uploadEMSImageList = []));
    setDisplayMediaList((EMSImageService.EKGUploadImageList = []));
    setDisplayMediaList((EMSAudioService.displayAudioList = []));
    setDisplayMediaList((EMSAudioService.uploadAudioList = []));
    setDisplayMediaList((EMSVideoService.displayEMSVideoList = []));
    setDisplayMediaList((EMSVideoService.uploadEMSVideoList = []));
  };

  // Every line of this was commented out, so a file over the limit was neither
  // uploaded nor reported: it just vanished, and the sender believed it had
  // been sent. Say so instead.
  const ifSizeIsLarge = (mediaData: any) => {
    const sizeInMb = Number(mediaData?.size);
    const sizeText = Number.isFinite(sizeInMb) ? `${sizeInMb.toFixed(1)} MB` : "";
    Toast.error(
      `${mediaData?.name ? `"${mediaData.name}" ` : "That file "}is too large to send` +
        `${sizeText ? ` (${sizeText})` : ""}. The limit is ${MAX_UPLOAD_SIZE_MB} MB.`
    );
  };

  const onAudioRecBtnClick = () => {
    setMediaType(CONSTANTS.MEDIA_TYPE.AUDIO);
    if (utilService.isWeb()) {
      setIsRecording(!isRecording);
      setAudioRecordCss(!isRecording);
      setDisableMediaSection(!isRecording);
      props.attachmentActive(!isRecording);
      if (!isRecording) {
        startAudioTimer();
        setMediaAttach(true);
      }
      if (isRecording) {
        stopTimerInUI();
      }
    }
    dataTransferService.transferEMSAudioMediaAction(!isRecording);
  };

  const onImageRecBtnClick = () => {
    setMediaType(CONSTANTS.MEDIA_TYPE.IMAGE);
    isSetFromEMTStartACase(false);
    setIsImageRecording(!isImageRecording);
    setMediaAttach(true);
    dataTransferService.transferEMSImageMediaAction(!isImageRecording);
  };

  const onEKGRecBtnClick = () => {
    setMediaType(CONSTANTS.MEDIA_TYPE.EKG);
    isSetFromEMTStartACase(true);
    setIsImageRecording(!isImageRecording);
    setMediaAttach(true);
    dataTransferService.transferEKGMediaAction(!isImageRecording);
  };

  const onCompleteMedia = (mediaType: Number) => {
    setMediaList();
    closeModalPopUp(mediaType);
  };

  const startAudioTimer = () => {
    const minsEle: any = document.querySelector(".ems-mins");
    const secEle: any = document.querySelector(".ems-sec");
    showTimerInUI(minsEle, secEle);
  };

  const setAudioRecordCss = (status: Boolean) => {
    const recDiv: any = document.getElementById("recButton");
    showRecordForMedia(recDiv, status);
  };

  const showTimerInUI = (minute: any, seconds: any) => {
    const startTime: any = new Date();
    let duration = 0;
    let stopTime = 0;
    const timer: any = setInterval(() => {
      let currTime: any = new Date();
      duration = stopTime + (currTime - startTime) / 1000;
      minute.innerHTML = (duration / 60) << 0;
      seconds.innerHTML = duration % 60 << 0;
    }, 10);

    setTimerIntervalID(timer);
  };

  const stopTimerInUI = () => {
    const minute: any = document.querySelector(".ems-mins");
    const seconds: any = document.querySelector(".ems-sec");
    minute.innerHTML = "";
    seconds.innerHTML = "";
    clearInterval(timerIntervalID);
  };

  const showRecordForMedia = (recordDiv: any, status: any) => {
    recordDiv.classList.add("notRec");
    if (status) {
      recordDiv.classList.add("Rec");
    } else {
      recordDiv.classList.add("notRec");
      recordDiv.classList.remove("Rec");
    }
  };

  const mapProviderName = () => {
    var providerName = "";
    if (!props.isProviderCard) {
      providerName =
        props.doctorListDataFromParent[0].firstName +
        " " +
        props.doctorListDataFromParent[0].lastName;
    } else {
      providerName =
        props.doctorListDataFromParent[0].first_name +
        " " +
        props.doctorListDataFromParent[0].last_name;
    }
    return providerName;
  };
  const handleOnFocusForIos = () => {
    const mediaListContainer = document.getElementById(
      "uploaded-media-list-container"
    );
    if (mediaListContainer && isPlatform("ios") && isSmallScreen) {
      mediaListContainer.style.setProperty("height", "29vh", "important");
    }
  };

  const handleOnBlurForIos = () => {
    const mediaListContainer = document.getElementById(
      "uploaded-media-list-container"
    );
    if (mediaListContainer && isPlatform("ios") && isSmallScreen) {
      mediaListContainer.style.setProperty("height", "57vh", "important");
    }
  };

  const handleOnBackClick = () => {
    if (props.doctorListDataFromParent || props.isMessageComponent) {
      props.onCancel();
    } else {
      if (location.state.isFromFileShareMainPage) {
        history.push({
          pathname: "/client/file-share",
          state: { sendBtnStatus: location.state.isSentButtonClicked },
        });
      } else {
        history.goBack();
      }
    }
  };

  const setMediaContainerPermission = () => {
    if (props.isFromCaseDetailsEdit) {
      return "disable-media-upload";
    } else {
      return "";
    }
  };

  return (
    <div
      className={`media-upload-screen ${
        props.isTransferred && props.isEMTUser ? "media-upload-screen-hide" : ""
      }`}
    >
      {props.isFromPatientForm && (
        <div>
          {viewAttachment && (
            <div
              className={`attachment-popover-ems ems-popover ${
                toggleAttachment ? "show-popover" : "hide-popover"
              }
              ${
                props.isFromCaseDetailsEdit
                  ? "case-details-media-attachment"
                  : ""
              }
              `}
            >
              <div
                className="close-icon-attachment"
                onClick={() => {
                  setToggleAttachment(false);
                  props.attachmentActive(false);
                  setDisableAudioSection(false);
                  setDisableMediaSection(false);
                }}
              >
                <IonIcon icon={close}></IonIcon>
              </div>

              <div
                className={`uploaded-media-list-container ${
                  props.isGroupMediaShare ? "uploaded-media-list-height" : ""
                }`}
                id="uploaded-media-list-container"
              >
                <div className="ems-media-list">
                  <IonRow>
                    {!_.isEmpty(displayMediaList) &&
                      displayMediaList.map((item: any) => {
                        return (
                          <IonCol
                            className={`media-upload-card-col-${item.clientMediaID}`}
                            size-lg={columnSize}
                            size="12"
                          >
                            <EMSMediaUploadCard
                              mediaItem={item}
                              onCardRemove={onCardRemove}
                            ></EMSMediaUploadCard>
                          </IonCol>
                        );
                      })}
                  </IonRow>
                </div>
              </div>
            </div>
          )}

          {showLoader && (
            <div
              className={`loader-div ${
                props.isGroupMediaShare
                  ? "uploaded-message-media-loader-div"
                  : ""
              }`}
            >
              <Loader></Loader>
            </div>
          )}

          <div
            className={`media-upload-main-container ${
              displayMediaList.length !== 0 ? setMediaContainerPermission() : ""
            }`}
          >
            <div className="message-main-container">
              {!props.isFromCaseDetailsEdit && (
                <div
                  className={`attachment-btn ${
                    props.isFromPatientForm ? "attachment-btn-align" : ""
                  }`}
                >
                  <IonButton
                    className="submit-btn button attached-media primary-btn btn-curved"
                    onClick={() => {
                      viewMediaAttachment();
                    }}
                    disabled={displayMediaList.length === 0}
                  >
                    <span className="icon-attach"></span> :{" "}
                    {displayMediaList.length}
                  </IonButton>
                </div>
              )}
              <div className="mediaupload-button-div">
                <div
                  className={`message-div ${
                    (utilService.isWeb() &&
                      !props.isSmallScreen &&
                      "emt-attach-large-screen",
                    props.isFromPatientForm ? "media-upload-ems" : "")
                  }`}
                >
                  {utilService.isWeb() && (
                    <Fragment>
                      <div
                        className={`add-media-icon-div ${
                          disableMediaSection ? "disable-form-section" : ""
                        }`}
                        onClick={(e: any) => {
                          setShowPopover(false);
                          openModalPopUp(CONSTANTS.MEDIA_TYPE.VIDEO);
                          isEKGSelected(false);
                        }}
                      >
                        <div
                          className="add-media-icon add-video-icon"
                          title="Take Video"
                        >
                          <div className="input-icon">
                            <IonIcon
                              icon={videocam}
                              className="media-upload-icon"
                            ></IonIcon>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`add-media-icon-div ${
                          disableMediaSection ? "disable-form-section" : ""
                        }`}
                        onClick={(e: any) => {
                          setShowPopover(false);
                          takePhoto();
                          isEKGSelected(false);
                        }}
                      >
                        <div
                          className="add-media-icon add-video-icon"
                          title="Take Image"
                        >
                          <div className="input-icon ">
                            <IonIcon
                              icon={camera}
                              className="media-upload-icon"
                            ></IonIcon>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`add-media-icon-div ${
                          disableAudioSection ? "disable-form-section" : ""
                        }`}
                        onClick={() => {
                          setShowPopover(false);
                          isAudioDeviceAvailable
                            ? onAudioRecBtnClick()
                            : showAudioErrorMessage();
                        }}
                      >
                        <div
                          className="add-media-icon add-video-icon"
                          title="Record Audio"
                        >
                          <div className="input-icon">
                            <IonIcon
                              icon={mic}
                              className="media-upload-icon"
                            ></IonIcon>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`add-media-icon-div  EKG-button ${
                          disableMediaSection ? "disable-form-section" : ""
                        }`}
                        onClick={(e: any) => {
                          setShowPopover(false);
                          takePhoto();
                          isEKGSelected(true);
                        }}
                      >
                        <div title="Take Image">
                          <div className="input-icon ekg-icon">
                            <div className="button ekg-button button-info btn-curved ml 5">
                              <span className="icon-lifeline"></span> {t("ekg")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  )}
                  {!utilService.isWeb() && (
                    <div className="mediaupload-button-div">
                      <div
                        className={`message-div small-screen-attach-icon ${
                          utilService.isWeb() &&
                          !props.isSmallScreen &&
                          "message-attach-large-screen"
                        }`}
                      >
                        <div
                          className={`add-media-icon-div ${
                            disableMediaSection ? "disable-form-section" : ""
                          }`}
                          onClick={(e: any) => {
                            setShowPopover(!isShowPopOver);
                            setShowRecordMediaPopover(false);
                          }}
                        >
                          <div className="add-media-icon" title="Attach Media">
                            <div
                              className="input-icon"
                              onClick={() => {
                                setShowPopover(false);
                              }}
                            >
                              <IonIcon
                                icon={attach}
                                className="media-upload-icon"
                              ></IonIcon>
                            </div>
                          </div>
                          <div
                            className={`file-attach-media attach-small-screen ${
                              isShowPopOver ? "show-popover" : "hide-popover"
                            }`}
                          >
                            <div className="close-icon">
                              <IonIcon icon={close}></IonIcon>
                            </div>
                            <div className="attach-media-icons-wrapper">
                              <div className="add-media-icon-div media-icon-for-small-screens">
                                <div className="add-media-icon icon-video-section">
                                  <input
                                    id="file"
                                    style={{
                                      opacity: "0",
                                      position: "absolute",
                                      width: "40px",
                                      height: "40px",
                                      top: 0,
                                      left: 0,
                                    }}
                                    multiple
                                    name="video-file"
                                    accept="video/mp4,video/x-m4v,video/*"
                                    type="file"
                                    value=""
                                    onChange={() =>
                                      webAttachMedia(CONSTANTS.MEDIA_TYPE.VIDEO)
                                    }
                                  />
                                  <div className="input-icon icon-div">
                                    <IonIcon
                                      icon={videocamOutline}
                                      className="media-upload-icon"
                                    ></IonIcon>
                                  </div>
                                  <div className="media-label">Video</div>
                                </div>
                              </div>
                              <div className="add-media-icon-div media-icon-for-small-screens">
                                <div
                                  className="add-media-icon icon-audio-div"
                                  onClick={() => {
                                    openFileSelector();
                                  }}
                                >
                                  <div className="input-icon icon-div">
                                    <IonIcon
                                      icon={mic}
                                      className="media-upload-icon"
                                    ></IonIcon>
                                  </div>
                                  <div className="media-label">Audio</div>
                                </div>
                              </div>
                              <div className="add-media-icon-div media-icon-for-small-screens">
                                <div className="add-media-icon icon-image-section">
                                  <input
                                    id="file"
                                    style={{
                                      opacity: "0",
                                      position:"absolute",width:"40px",
                                      height:"40px",top:0,left:0
                                    }}
                                    multiple
                                    name="image-file"
                                    accept="image/*"
                                    type="file"
                                    value=""
                                    onInput={() => {
                                      webAttachMedia(
                                        CONSTANTS.MEDIA_TYPE.IMAGE
                                      );
                                    }}
                                  />
                                  <div className="input-icon icon-div">
                                    <IonIcon
                                      icon={imagesOutline}
                                      className="media-upload-icon"
                                    ></IonIcon>
                                  </div>
                                  <div className="media-label">Image</div>
                                </div>
                              </div>
                              <div className="add-media-icon-div media-icon-for-small-screens">
                                <div className="add-media-icon icon-image-section">
                                  <input
                                    id="file"
                                    style={{
                                      opacity: "0",
                                      position:"absolute",width:"40px",
                                      height:"40px",top:0,left:0
                                    }}
                                    multiple
                                    name="ekg-file"
                                    accept="image/*"
                                    type="file"
                                    value=""
                                    onInput={() => {
                                      webAttachMedia(CONSTANTS.MEDIA_TYPE.EKG);
                                    }}
                                  />
                                  <div className="input-icon icon-div">
                                    <IonIcon
                                      icon={imagesOutline}
                                      className="media-upload-icon"
                                    ></IonIcon>
                                  </div>
                                  <div className="media-label">EKG</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {!utilService.isWeb() && (
                    <Fragment>
                      <div
                        className="add-media-icon-div"
                        onClick={(e: any) => {
                          setShowPopover(false);
                          openModalPopUp(CONSTANTS.MEDIA_TYPE.VIDEO);
                          isEKGSelected(false);
                        }}
                      >
                        <div className="add-media-icon" title={t("takeVideo")}>
                          <div className="input-icon">
                            <IonIcon
                              icon={videocam}
                              className="media-upload-icon"
                            ></IonIcon>
                          </div>
                        </div>
                      </div>
                      <div
                        className="add-media-icon-div"
                        onClick={onImageRecBtnClick}
                      >
                        <div
                          className="add-media-icon add-video-icon"
title={t("takeImage")}                        >
                          <div className="input-icon ">
                            <IonIcon
                              icon={camera}
                              className="media-upload-icon"
                            ></IonIcon>
                          </div>
                        </div>
                      </div>
                      <div
                        className="add-media-icon-div"
                        onClick={() => {
                          setShowPopover(false);
                          isAudioDeviceAvailable
                            ? onAudioRecBtnClick()
                            : showAudioErrorMessage();
                        }}
                      >
                        <div
                          className="add-media-icon add-video-icon"
title={t("recordAudio")}                        >
                          <div className="input-icon">
                            <IonIcon
                              icon={mic}
                              className="media-upload-icon"
                            ></IonIcon>
                          </div>
                        </div>
                      </div>
                      <div
                        className="add-media-icon-div EKG-button"
                        onClick={onEKGRecBtnClick}
                      >
                        <div title="Take Image">
                          <div className="input-icon ekg-icon">
                            <div className="button ekg-button button-info btn-curved">
                              <span className="icon-lifeline"></span> {t("ekg")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  )}

                  {isSmallScreen && (
                    <EMSVideoComponent
                      onComplete={() => {
                        onCompleteMedia(CONSTANTS.MEDIA_TYPE.VIDEO);
                      }}
                      selectedDoctorData={selectedDoctorData}
                      isStatusBoard={props.isStatusBoard}
                      smsThread={props.smsThread}
                      isFromEMT={true}
                    ></EMSVideoComponent>
                  )}
                  <div
                    className={`emt-reply-media-upload-text-box ${
                      props.isGroupMediaShare
                        ? "media-upload-text-box-width"
                        : ""
                    }
                    ${isRecording ? "hide-media-upload-text-box" : ""}
                    `}
                    id="media-upload-text-box"
                  >
                    <div
                      className={`rec-audio-button-wrapper clickable ${
                        isRecording ? "show-rec-wrapper" : "hide-rec-wrapper"
                      }`}
                      onClick={() => {
                        isAudioDeviceAvailable
                          ? onAudioRecBtnClick()
                          : showAudioErrorMessage();
                      }}
                    >
                      <div className="rec-btn-div">
                        <button id="recButton"></button>
                      </div>

                      <div className="timer-div">
                        <span className="ems-mins">0</span>
                        <span className="divider">:</span>
                        <span className="ems-sec">0</span>
                      </div>
                    </div>
                    <EMSAudioComponent
                      onCompleteMedia={() => {
                        onCompleteMedia(CONSTANTS.MEDIA_TYPE.AUDIO);
                      }}
                      selectedDoctorData={selectedDoctorData}
                      isStatusBoard={props.isStatusBoard}
                      smsThread={props.smsThread}
                    ></EMSAudioComponent>
                    <span
                      className={` ${
                        utilService.isWeb()
                          ? "show-text-area"
                          : "hide-text-area"
                      }`}
                      onFocus={handleOnFocusForIos}
                      onBlur={handleOnBlurForIos}
                      id="mediaUploadTextBox"
                      placeholder="Type here"
                      role="textbox"
                      contentEditable
                    ></span>
                  </div>

                  <EMSImageComponent
                    onComplete={() => {
                      onCompleteMedia(CONSTANTS.MEDIA_TYPE.IMAGE);
                    }}
                    selectedDoctorData={selectedDoctorData}
                    isStatusBoard={props.isStatusBoard}
                    smsThread={props.smsThread}
                    isFromEMS={isFromEMTStartACase}
                  ></EMSImageComponent>
                </div>
              </div>
            </div>
          </div>

          <IonModal
            isOpen={showVideoUploadModal}
            backdropDismiss={false}
            className="audio-upload-modal video-upload-modal"
          >
            <div
              className="close-icon"
              onClick={() => {
                setShowVideoUploadModal(false);
                setMediaList();
              }}
            >
              <IonIcon icon={close}></IonIcon>
            </div>
            <EMSVideoComponent
              onComplete={() => {
                onCompleteMedia(CONSTANTS.MEDIA_TYPE.VIDEO);
              }}
              selectedDoctorData={selectedDoctorData}
              isStatusBoard={props.isStatusBoard}
              smsThread={props.smsThread}
              isFromEMT={true}
            ></EMSVideoComponent>
          </IonModal>

          {props.isFromCaseDetailsEdit && (
            <>
              <div className="case-details-uploaded-attachment">
                <div className="ems-media-list">
                  <IonRow>
                    {!_.isEmpty(displayMediaList) &&
                      displayMediaList.map((item: any) => {
                        return (
                          <IonCol
                            className={`media-upload-card-col-${item.clientMediaID}`}
                            size-lg="10"
                            size-md="12"
                            size="12"
                          >
                            <EMSMediaUploadCard
                              mediaItem={item}
                              onCardRemove={onCardRemove}
                              isFromCaseEdit={props.isFromCaseDetailsEdit}
                            ></EMSMediaUploadCard>
                          </IonCol>
                        );
                      })}
                  </IonRow>
                </div>
              </div>
              <div className="upload-media-button-container case-history-media-upload">
                <div className="send-button-div">
                  <IonButton
                    className="submit-btn button primary-btn btn-curved"
                    onClick={() => {
                      let mediaUploadMessage = "sample";
                      setParams(mediaUploadMessage);
                    }}
                    disabled={displayMediaList.length === 0}
                  >
                    Upload
                  </IonButton>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default EMTMediaUpload;
